import * as React from 'react';
import Typography from '@mui/material/Typography';
import { getConfigText, newLineParser } from "../utils";
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from "@mui/material/Grid";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CircleIcon from '@mui/icons-material/Circle';
import TextField from '@mui/material/TextField';


export default function WhereDoIStandPage({ pageId, studentAnswers, setStudentAnswers }) {


    const skills = getConfigText(pageId, "vaardigheden");
    const cardSM = Math.floor(12 / skills.length);

    return (
        <React.Fragment>
            <Typography
                variant="h5"
                gutterBottom
            >
                Waar sta ik nu?
            </Typography>

            <Typography variant="body2" gutterBottom style={{ whiteSpace: "pre-line" }}>
                {newLineParser(getConfigText(pageId, "waar_sta_ik_nu")['inleiding'])
                }
            </Typography>            

            <Typography variant="body2" gutterBottom component="div">
            <List>
                {getConfigText(pageId, "waar_sta_ik_nu")['vragen_1'].map((c, i) => (
                    <ListItem key={"vragen1_" + i}>
                        <ListItemIcon >
                            <CircleIcon sx={{ fontSize: '0.7rem' }} />
                        </ListItemIcon>
                        {c}
                    </ListItem>
                ))}
            </List>            
            <TextField
                id="outlined-multiline-static"
                label="Geef hier je antwoord"
                multiline
                fullWidth
                minRows={2}
                defaultValue={studentAnswers.a1}
                onChange={(event) => {
                    setStudentAnswers({
                        ...studentAnswers,
                        a1: event.target.value
                    });
                  }}
            />            

            </Typography>

            <Typography variant="body2" gutterBottom component="div">
            <List>
                {getConfigText(pageId, "waar_sta_ik_nu")['vragen_2'].map((c, i) => (
                    <ListItem key={"vragen2_" + i}>
                        <ListItemIcon >
                            <CircleIcon sx={{ fontSize: '0.7rem' }} />
                        </ListItemIcon>
                        {c}
                    </ListItem>
                ))}
            </List>              
            <TextField
                id="outlined-multiline-static"
                label="Geef hier je antwoord"
                multiline
                fullWidth
                minRows={2}
                defaultValue={studentAnswers.a2}
                onChange={(event) => {
                    setStudentAnswers({
                        ...studentAnswers,
                        a2: event.target.value
                    });
                  }}
            />            
            </Typography>    

            <Typography variant="body2" gutterBottom component="div">
                Klik op volgende om te zien aan welke vaardigheden en leerdoelen je in deze module gaat werken.
            </Typography>            


        </React.Fragment>
    );
}
